import React, { Fragment, useEffect, useMemo } from 'react';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import { Autocomplete } from '@material-ui/lab';
import { Layers } from '@material-ui/icons';
import LayerDivitionCombo from './LayerDivitionCombo';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import useLayerContext from 'contexts/layerContext';

// Aprox .333
const hexaAlpha = '55';

export function LayerColorIcon({ layer, style, alpha }) {
  return (
    <div
      style={{
        height: '20px',
        width: '20px',
        borderRadius: '5px',
        backgroundColor:
          layer?.color === undefined ? undefined : layer.color + (alpha || hexaAlpha),
        border: layer?.color === undefined ? undefined : '2px solid black',
        ...style,
      }}
    >
      {layer?.color === undefined && <Layers />}
    </div>
  );
}

function LayerCombo(props) {
  const { defaultLayer, ignoreExcluded = false, lockDivition = false } = props;
  const { onChange, useDivition = true, isFilter = false, disabled = false } = props;
  const { label = 'Capa', required = false } = props;
  const { layers, selectedDivition, selectedLayer, setSelectedLayer } = useLayerContext();

  // Agregando la opción de 'Todas las capas' si es un filtro
  const options = useMemo(() => {
    let filteredLayers = layers.filter((layer) => layer.divition.id === selectedDivition?.id);
    if (isFilter) return [{ name: 'Todas las capas' }, ...filteredLayers];
    return filteredLayers;
  }, [layers, selectedDivition]);

  useEffect(() => {
    if (defaultLayer !== undefined) {
      setSelectedLayer(defaultLayer);
    }
  }, [defaultLayer]);

  return (
    <GridContainer>
      {useDivition && (
        <GridItem xs={4} style={{ padding: '0 0 0 15px' }}>
          <LayerDivitionCombo ignoreExcluded={ignoreExcluded} lockDivition={lockDivition} />
        </GridItem>
      )}
      <GridItem xs={useDivition ? 8 : 12} style={{ padding: '0 15px 0 0' }}>
        <Autocomplete
          options={options}
          getOptionLabel={(option) => option.name}
          disableClearable={isFilter}
          value={selectedLayer || (isFilter ? options[0] : null)}
          disabled={disabled}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              margin="normal"
              required={required}
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position="start">
                    <LayerColorIcon layer={selectedLayer} />
                  </InputAdornment>
                ),
              }}
            />
          )}
          renderOption={(option) => {
            return (
              <Fragment>
                <LayerColorIcon layer={option} style={{ marginRight: '15px' }} />
                {option.name}
              </Fragment>
            );
          }}
          onChange={(e, item) => {
            if (disabled) return;
            if (onChange !== undefined) {
              onChange(e, item);
            }
            if (!!item) {
              setSelectedLayer(item);
              return;
            }
          }}
        />
      </GridItem>
    </GridContainer>
  );
}

export default LayerCombo;
